import { useContext } from 'react';
import { createContext } from 'react';

import { AddToCartButtonProps } from '../@types/AddToCartButtonProps';

export const AddToCartButtonContext = createContext<AddToCartButtonProps>({} as AddToCartButtonProps);

AddToCartButtonContext.displayName = 'AddToCartButton';

const AddToCartButtonProvider = (props: AddToCartButtonProps) => (
	<AddToCartButtonContext.Provider value={props}>{props.children}</AddToCartButtonContext.Provider>
);

export const useAddToCartButton = () => {
	const context = useContext(AddToCartButtonContext);

	return context;
};

export default AddToCartButtonProvider;
